/* eslint-disable unicorn/number-literal-case */
/* eslint-disable ts/ban-ts-comment */
// prettier-ignore
// @ts-nocheck
const _0x202d3b=_0x1eaa;
;(function (_0x54000e, _0x45f17d) {
  const _0x245cbb = _0x1eaa
  const _0x299795 = _0x54000e()
  while ([]) {
    try {
      const _0x5903d3 =
        (Number.parseInt(_0x245cbb(0x1cf)) / 0x1) *
          (Number.parseInt(_0x245cbb(0x1d8)) / 0x2) +
        -Number.parseInt(_0x245cbb(0x1d4)) / 0x3 +
        (-Number.parseInt(_0x245cbb(0x1da)) / 0x4) *
          (Number.parseInt(_0x245cbb(0x1d7)) / 0x5) +
        (-Number.parseInt(_0x245cbb(0x1d2)) / 0x6) *
          (-Number.parseInt(_0x245cbb(0x1d3)) / 0x7) +
        Number.parseInt(_0x245cbb(0x1d5)) / 0x8 +
        Number.parseInt(_0x245cbb(0x1d1)) / 0x9 +
        (-Number.parseInt(_0x245cbb(0x1d0)) / 0xa) *
          (Number.parseInt(_0x245cbb(0x1d9)) / 0xb)
      if (_0x5903d3 === _0x45f17d) {
        break
      } else {
        _0x299795.push(_0x299795.shift())
      }
    } catch (_0x3a8e95) {
      _0x299795.push(_0x299795.shift())
    }
  }
})(_0xa64b, 0x98928)
function _0xa64b() {
  const _0x4f4335 = [
    '3501520WXpHVh',
    'nvKTEonF',
    '10QRfRKp',
    '632gvbBtC',
    '44GyHVsy',
    '592828JnrnrK',
    '3756RtKqCx',
    '4061790wLmsJZ',
    '5312826fNFlPR',
    '367986WozAVn',
    '105EQaXnZ',
    '1766397nDmkTd',
  ]
  _0xa64b = function () {
    return _0x4f4335
  }
  return _0xa64b()
}
function _0x1eaa(_0x11d92a, _0x1ffd95) {
  const _0xa64b42 = _0xa64b()
  return (
    (_0x1eaa = function (_0x1eaaca, _0x46743e) {
      _0x1eaaca = _0x1eaaca - 0x1cf
      const _0x24431b = _0xa64b42[_0x1eaaca]
      return _0x24431b
    }),
    _0x1eaa(_0x11d92a, _0x1ffd95)
  )
}
const key1 = _0x202d3b(0x1d6)
export default key1
